var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona",
    d: "M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm0,5.5A1.375,1.375,0,1,1,9.625,6.875,1.375,1.375,0,0,1,11,5.5Zm1.719,11H9.281a1.031,1.031,0,1,1,0-2.062h.688v-2.75H9.625a1.031,1.031,0,0,1,0-2.063H11a1.032,1.032,0,0,1,1.031,1.031v3.781h.688a1.031,1.031,0,1,1,0,2.062Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNote);
export default __webpack_public_path__ + "static/media/info_note.ff891ec3c74ebad1b5d8802a4eb58b50.svg";
export { ForwardRef as ReactComponent };